import { FlexBox, Icon } from '@dixa/lib-shared-habla';

import { AppLink } from 'components/appLink';

type Props = {
  formName: string;
};

export function FormEditPageTitle({ formName }: Props): JSX.Element {
  return (
    <FlexBox gap="200" alignItems="center">
      <AppLink path="/settings/custom-forms" style={{ color: 'inherit' }}>
        Forms
      </AppLink>

      <Icon name="angle-right" />

      {formName}
    </FlexBox>
  );
}
